import { useTranslator } from "../../common/state/translatorState";
import { LanguageInfoDTO } from "../../services/contactReportsApi";

export function useLanguageDefaultName() {
  const t = useTranslator();
  return (language: LanguageInfoDTO) => {
    return t.getTranslatedValue('Language', `Language.${language.id}.DefaultName`, language.defaultName ?? '');
  };
}